import PropTypes from "prop-types";
import React from "react";
import useDocumentCategories from "~/hooks/documents/useDocumentCategories";
import Select from "./SelectWrapper/Select";

const DocumentCategorySelect = ({
  id = "input_category",
  value,
  onChange,
  placeholder = "Select Category",
  isClearable = true,
  isSearchable = false,
  ...restProps
}) => {
  const { options, loading } = useDocumentCategories();

  return (
    <Select
      validateValue
      id={id}
      name="category"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      isClearable={isClearable}
      isSearchable={isSearchable}
      isLoading={loading}
      options={options}
      {...restProps}
    />
  );
};

DocumentCategorySelect.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
};

export default DocumentCategorySelect;
